export default {
  title: 'Devices',
  phone: 'Phone',
  phoneNotPaired: 'No phone is paired yet. Pair their phone first, then you can add a second device.',
  secondDevice: 'Second device',
  intro: 'Only the phone records attendance and location. A second device, such as a tablet, shows the same person’s rosters, jobs and chat.',
  addSecondDevice: 'Add second device',
  pairedOn: 'Paired {date}',
  lastContact: 'Last contact {ago}',
  noContactYet: 'No contact yet',
  appVersionValue: 'App {version}',
  remove: 'Remove',
  removeTitle: 'Remove this second device?',
  removeMessage: '{device} will be signed out of CrewPresence straight away. You can add it again with a new PIN.',
  removedToast: 'Second device removed.',
  addTitle: 'Add a second device for {name}',
  addDescription: 'Generate a one-time PIN and enter it in the CrewPresence app on the tablet.',
  addNote: 'The tablet needs the latest CrewPresence app. It shows rosters, jobs and chat, but only the phone records attendance and location.',
  generatePin: 'Generate PIN',
  pinInstructions: 'Open CrewPresence on the tablet and enter this PIN. This window updates itself the moment the tablet is added.',
  added: 'Second device added',
  addedMessage: 'This device now shows {name}’s rosters, jobs and chat. It will not record attendance or location.',
  addedToast: 'Second device added.',
  listMoreOne: '+1 second device',
  listMoreOther: '+{count} second devices',
  unpairAlsoOne: 'Their second device is signed out too.',
  unpairAlsoOther: 'Their {count} second devices are signed out too.',
}
